import { useQuery } from "@tanstack/react-query";
import {
  fetchStudiomateLectureDetail,
  type GetStudiomateLectureDetailResponse,
} from "@/services/studiomate-lecture-detail";

export function useStudiomateLectureDetail(lectureId: number | undefined) {
  return useQuery<GetStudiomateLectureDetailResponse>({
    queryKey: ["studiomate-lecture-detail", lectureId],
    queryFn: () => fetchStudiomateLectureDetail(lectureId!),
    enabled: !!lectureId,
    staleTime: 10 * 60 * 1000,
  });
}
